<template>
    <div class="p-0">
        <div class="font-color-171717">
    
    
            <div style="width: 100%;background-size: cover; margin: auto;color: #fff">
                <CCard class="bg-white b-20 m-3 p-20 mb-5" style="border:none;">
                    <CRow class="m-2">
                        <CCol sm="12">
                            <h3 class="custom-40px-500 text-center mt-3">Detailed Candidate Interview Videos</h3>
                            <p class="custom-18px-400 text-center m-2 mb-2">Empower your company with seamless access to detailed interview videos, <br /> enabling comprehensive evaluation of candidate qualifications and suitability for the role</p>
                        </CCol>
                        <CCol sm="12">
                            <CRow>
                                <CCol sm="10">
                                   
                                </CCol>
                                <CCol sm="2" style="margin-top:-30px;">
                                  
                                </CCol>
    
                            </CRow>
                            <template v-if="Busy == true">
                                                                                                <div class="container text-center">
                                                                                                  <pulse-loader
                                                                                                    :loading="loading"
                                                                                                    :color="color"
                                                                                                    :size="size"
                                                                                                  ></pulse-loader>
                                                                                                </div>
</template>

                      
<CCol sm="12" md="4" lg="3" style="float:left">
                            <div>
                                <CRow>
                                    <CCol sm="12" class="d-flex font-color-171717">
                                        <label class="m-2">Show </label><select v-model="perPage" id="entries" class="form-control">
                                        <option :value="10">10</option>
                                        <option :value="25">25</option>
                                        <option :value="50">50</option>
                                        <option :value="100">100</option>
                                    </select> <label class="m-2">entries </label>
                                    </CCol>
                                </CRow>
    
    
                            </div>
                        </CCol>
                        <CCol sm="12" md="4" lg="3" style="float:right">
                            <div>
                                <CRow>
                                    <CCol sm="12" class="mb-2">
                                        <CInput type="text" placeholder="Search...." v-model.lazy="SearchQuery" @change="applyFilter()" />
                                    </CCol>
                                </CRow>
    
    
                            </div>
                        </CCol>   
                        <div style="clear:both"></div>
                         <CCol sm="12">  
                       
                        <CSwitch
  variant="3d"
  color="primary"
  size="sm"
  type="checkbox"
  name="isComplete"
  :checked="isComplete"
  @update:checked="(val) => {
    isComplete = val; 
    radio = val; 
    loadData();
    getTotalReport(); // Call the loadData method after updating isComplete and radio
  }"
/> <label class="font-color-171717 ml-2">  Show Complete Report</label>
</CCol>  
<table class="table table-responsive-sm" v-if="Array.isArray(filteredList) && filteredList.length > 0">
                                <thead class="custom-table">
                                    <th>CandidateName</th>
                                    
                                    <th>Interview</th>
                                    <th>Date</th>
                                    <th>Preview</th>
                                    <th>Video</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,index) in filteredList" :key="item.id">
                                        <td>
                                            <input type="checkbox" v-model="selectedItems" :value="item.sessionId" class="mr-2" />
        <img v-if="item.profilePhoto !== '' && item.profilePhoto !== null" :src="item.profilePhoto" width="30px" height="30px" style="border-radius: 50%; border: 1px solid #fff; object-fit: cover;" />
        <img v-else src="../assets/img/2-2.png" width="30px" height="30px" style="border-radius: 50%; border: 1px solid #fff; object-fit: cover;" />
        <label class="custom-12px-500 ml-2"> <label v-if="item.candidateDetail != 'undefined'">  {{ item.candidateDetail }} </label>({{ item.name }})</label>
    </td>
   
    <td>
        {{ item.sessionName }}
    </td>
    <td>
        <label>{{ item.sessionTime | moment("DD-MMM-YYYY") }} </label>
     
    </td>
    <td>
        <label class="custom-border-purple p-2 mr-5 text-white" @click="openPopupShowQuestion(item)">Display</label>
    </td>
    <td>
        <label class="custom-border-purple p-2 mr-5 text-white" @click="openVideoPopup(item.sessionId)" v-if="user.id ===69">Watch</label>
        <label class="custom-border-purple p-2 mr-5 text-white bg-C2C2C4" v-else>Watch</label>
    </td>
                                        </tr>
                                        </tbody>
                                        </table>  
                      
                    
                                        <div v-else class="no-data-message">
    
    <div class="text-center m-0">
        <br /> <br /> <br />
        <div class="no-data-message text-center">
            <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;" />
            <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
            <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
        </div>
    </div>

</div>
                       
<div style="clear:both"></div>
                        <CRow>
                            <CCol sm="12" md="12" lg="12">
                                <button @click="loadFirstPage" :disabled="currentPage === 1" class="custom-btn-page" style="border-bottom-left-radius: 5px;
        border-top-left-radius: 5px;">First</button>
                                <button @click="loadPrevPage" :disabled="currentPage <= 1" class="custom-btn-page"> < Previous</button>
                                <span v-for="pageNumber in visiblePageNumbers" :key="pageNumber">
                                            <button @click="loadPage(pageNumber)" :class="{ active: pageNumber === currentPage }" class="custom-btn-page">{{ pageNumber }}</button>
                                        </span>
                                <button @click="loadNextPage" :disabled="!hasNextPage" class="custom-btn-page" style="border-bottom-right-radius: 5px;
        border-top-right-radius: 5px;">Next ></button>
    <button @click="loadLastPage" :disabled="currentPage === totalPages" class="custom-btn-page" 
        style="border-bottom-right-radius: 5px; border-top-right-radius: 5px;">
    Last
</button>
                            </CCol>
                        </CRow>
                        <div class="text-center">
                  <label class="custom-border-purple p-2 mr-5 text-white" @click="submitSelected">Submit</label>
                </div>
</CCol>
    
                    </CRow>
                </CCard>
                <br /><br /><br />
            </div>
    
           
            <div v-if="ispopupVisible2" class="popup-all backdrop-all" style="z-index:1">
                <div class="popup-all2">
                    <div></div>
                    <CRow>
                        <CCol sm="11"><label class="custom-20px-600 font-color-171717">Details</label></CCol>
                        <CCol sm="1"> <img src="../assets/img/close.png" style="max-width:50px;text-align:right" @click="closePopup1" /></CCol>
                    </CRow>
                    <div class="custom-scroll">
                        <CCard class="p-20 font-color-171717 m-2">
                            <CRow class="m-2 p-20">
                                <CCol sm="12">
                                    <iframe :src="questionVideo.Url" frameborder="0" allowfullscreen style="width: 100%;height:450px"></iframe>
                                    <CRow>
                            <CCol sm="6"> <label class="ml-2 mr-2 mt-2">Current Video Question :{{ questionVideo.IndexNo }}</label></CCol> 
                        <CCol sm="6">                       <span class="custom-border-purple p-2 text-center text-white" @click="nextQuestion(questionVideo.IndexNo, questionVideo.SessionId)">
                         <label class="ml-2 mr-2 mt-2">Next Video</label></span></CCol>
                        </CRow>
                         <h4 class="mt-2">Question:</h4>
                         <p>{{ questionVideo.Question }}</p>
                         <h4 class="mt-3">Answer:</h4>
                         <!-- <p>{{ questionVideo.Answer }}</p> -->
                         <p class="custom-12px-400" v-html="formattedAnswer"></p>
                         <h4 class="mt-3">Uploaded Files:</h4>
                                            <ul class="file-list">
                                                <li v-for="(file, index) in doc" :key="index">
                                                    <div class="file-info">
                                                    <img src="../assets/img/iconfile.png" width="40px" class="file-icon" />
                                                    <span class="file-name ml-3"><a :href="file.Url" target="_blank">{{ file.FileName }}</a></span>
                                                    </div>
                                                </li>
                                            </ul>
                                </CCol>
                                <CRow id="printsection">
                                <CCol sm="5">
    
                                    <h3 class="custom-18px-500 font-inter mt-2">
                                        4 personal character indicators
                                    </h3>
                        <br />
                    <CCard>
                        <br />
                        <CRow class="m-0">
                            <CCol v-if="report === 'Not available yet.'" sm="6">
                                    <CRow class="text-center m-0">
                                        <CChartDoughnut :datasets="defaultDatasets" />
                                        <br />
                                        <span class="text-center ml-2">No data available.</span>
                                    </CRow>

                                </CCol>

                             <CCol v-else sm="6" v-for="(dataset, index) in datasets" :key="index">
                                            <div class="text-center">
                                                <CChartDoughnut :datasets="[dataset]" :labels="[dataset.label]" :options="chartOptions"/>

                                            </div>
                                        </CCol>
                                    </CRow>
                                    <br />
                                </CCard>
                                                    
                                <CCard>
                                    <h3 class="custom-14px-400 font-inter m-2">Overall performance</h3>
                                    <CChartRadar
                                        :datasets="radarChartData.datasetsRadar"
                                        :options="responsive"
                                        :labels="radarChartData.labels"
                                        />
                                    <br />      
                                </CCard>
                            </CCol>
                            <CCol sm="7">
                                <CCol sm="12">
                                    <h3 class="custom-18px-500 font-inter mt-2">Detail Explanation & Score</h3>
                                    <h3 class="custom-14px-400 font-inter">Ranked based on users answer</h3>
                                    <CCard>

                                        <CRow class="m-1">
                                            <CCol v-if="report === 'Not available yet.'" sm="6">
                                                <p>No data available.</p>
                                            </CCol>
                                            <CCol v-else sm="6" v-for="(trait, index) in report" :key="index">
                                                <div>
                                                    
                                                    <CRow class="mt-2">
                                                        <CCol sm="8"><h4 class="custom-18px-600 font-color-171717 font-inter font-small">{{ trait.Type }}</h4></CCol>
                                                        <CCol sm="4"><h4 class="custom-16px-500 font-color-171717 font-inter">{{ trait.Value }} /10</h4></CCol>
                                                        
                                                        <CCol sm="12">
                                                            <p class="custom-14px-400 mt-2 font-color-171717">{{ trait.Details }}</p>
                                                        </CCol>
                                                        <CCol sm="12">
                                                            <!-- <progress :value="trait.Value" max="10" show-percentage style="width:100%"></progress> -->
                                                            <CProgress :value="trait.Value" show-value color="success" max="10" :animated="animate" class="mb-2" />
                                                        </CCol>
                                                    </CRow>
                                                </div>
                                            </CCol>
                                        </CRow>

                                    </CCard>


                                </CCol>
                            </CCol>
                            <CCol sm="12">
                                <h3 class="custom-16px-600">Summary</h3>
                                <h4 class="custom-18px-400 font-small" v-if="reportSummary != null">  <pre>{{ reportSummary }}</pre></h4>
                            </CCol>
                            </CRow>
                            <CCol sm="6"> <label class="custom-border-purple-white p-2 mr-2 font-color-928AFD text-center mt-5 mb-5" style="width:100%" v-on:click="PrintSectionInvoice"><img style="width:20px" src="../assets/img/Download.png" />Download</label></CCol>
                            <CCol sm="6"> <label class="custom-border-purple p-2 mr-2 text-white text-center mt-5 mb-5" style="width:100%">Continue</label></CCol>

                        </CRow>
                        </CCard>
                    </div>
                    </div>
                </div>
            </div>

            <div v-if="ispopupVisible3" class="popup-all backdrop-all">
                <div class="popup-all2">
                    <CRow>
                        <CCol sm="11"><label class="custom-20px-600 font-color-171717">Rate Your Candidate</label></CCol>
                        <CCol sm="1">  <img src="../assets/img/close.png" style="max-width:50px;text-align:right" @click="closePopup2" /></CCol>
                    </CRow>
                  
                                <div class="custom-scroll">
                                    <CCard class="p-2">
                                        <label class="custom-14px-400">Your Rate</label>
                                        <CInput type="text" />

                                        <label class="custom-14px-400">Title</label>
                                        <CInput type="text" />

                                        <label class="custom-14px-400">Description</label>
                                        <tinymce
                    id="d1"
                    v-model="Content"
                    placeholder="Enter Your Content"
                    class="mb-2"
                  ></tinymce>
                  <label class="custom-14px-400">Review By</label>
                                        <CSelect></CSelect>
                                        <div class="text-center">
                                            <label class="custom-border-purple p-2 mr-5 text-white">Submit</label>
                                        </div>
                                       
                                    </CCard>
                                   
                                </div>
                     
    
    
                </div>
            </div>

            <div v-if="ispopupShowQuestion" class="popup-all backdrop-all">
              <div class="popup-all1 font-color-171717">
                <div class="text-right">
                  <img src="../assets/img/close.png" style="max-width:50px;" @click="closeVideoShowQuestion" />
                </div>
                <span class="mt-1 custom-light-purple">Question {{ questionVideo.IndexNo }}:</span>
                <p class="mt-3 custom-12px-600 text-black">
                  <strong>{{ questionVideo.Question }}</strong>
                </p>
                <p class="custom-12px-400">{{ questionVideo.Answer }}</p>
              </div>
            </div>

            <div v-if="isPopupError" class="popup-all backdrop-all">
            <div class="popup-all1">
              <div class="text-right">
                  <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopup" />
                </div>
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 100px" src="../assets/img/error.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                      Oops!
                    </h3>
                    <h4 class="custom-16px-400 text-center font-color-687588">You have exceeded the credit. Please reduce the number of selected candidates or you can add credits.</h4>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closePopup" style="width:100px">
                        <span class="ml-2 mr-2">OK</span>
                    </CButton>
                </div>
            </div>
        </div>

        <div v-if="isPopupSuccess" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                        Successfully Saved
                    </h3>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px">
                        <span class="ml-2 mr-2">OK</span>
                    </CButton>
                </div>
            </div>
        </div>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";
import VueHtmlToPaper from "vue-html-to-paper";
const options = {
    name: "_blank",
    specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
    styles: [
        "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
        "https://unpkg.com/kidlat-css/css/kidlat.css",
        "../assets/css/pagebreak.css"
    ]
};
Vue.use(VueHtmlToPaper, options);

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartDoughnut } from '@coreui/vue-chartjs';
import { CCol } from '@coreui/vue';
import { CChartRadar } from '@coreui/vue-chartjs';

import html2pdf from 'html2pdf.js';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';






export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        PulseLoader,
        CChartDoughnut,
        CCol,
        CChartRadar,
        html2canvas,
        jsPDF
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrNoArrow,
            ispopupVisible2: false,
            ispopupVisible3: false,
            list: [],
            user: {},
            videoUrl: '',
            searchQuery: '',

            questionVideo: {},
            Busy: false,
            report: [],
            reportRadar: [],
            reportRank: [],
            reportSummary: '',
            datasets: [],
            itemsPerPage: 10,
            animate: "",
            size: "",
            color: "",
            loading: "",
            maxScore: 10, // Maximum score possible
            max: 10,
            doc:[],
            chartOptions: {
                plugins: {
                    legend: {
                        display: true,
                        position: 'bottom', // Place legend at the bottom
                        labels: {
                            fontColor: 'black', // Adjust font color as needed
                            fontSize: 14,
                        },
                    },
                    doughnutBackgrounds: {
                        colors: [
                            { backgroundColor: 'rgba(0, 0, 0, 0.1)' }, // Example background color
                        ],
                    },
                    tooltip: {
                        enabled: true, // Enables tooltip
                        callbacks: {
                            label: function(context) {
                                // Display only value inside the tooltip
                                const value = context.raw || 0;
                                return `${value}`;
                            },
                        },
                    },
                    datalabels: {
                        display: function(context) {
                            // Show datalabels only for the value part
                            return context.dataIndex === 0;
                        },
                        formatter: function(value) {
                            return value; // Display the value
                        },
                        color: '#000', // Set text color
                        font: {
                            size: 14, // Set font size
                            weight: 'bold', // Set font weight
                        },
                    },
                },
            },
            fields: [{
                    key: 'CandidateName'
                }, {
                    key: 'Email'
                },
                {
                    key: 'Interview'
                }, {
                    key: 'Video'
                },
            ],
            radarChartData: {
                labels: ['Type1', 'Type2', 'Type3'],
                datasetsRadar: [{
                    label: 'AI Video Score',
                    backgroundColor: 'rgba(145, 138, 246, 0.25)',
                    borderColor: 'rgba(113, 100, 169, 1)',
                    data: []
                }]
            },
            defaultOptionsRadar: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    r: {
                        beginAtZero: true,
                        min: 1,
                        suggestedMax: 10,
                        ticks: {
                            stepSize: 1,
                            callback: function(value) {
                                // Exclude the label for 0 but ensure scale starts at 0
                                //  return value === 0 ? '' : value;
                            }
                        },
                        grid: {
                            circular: true
                        },
                        pointLabels: {
                            display: true,
                            centerPointLabels: true
                        }
                    }
                }
            },

            options: {
                perPage: 10,
                pagination: true,
                filterable: false,
                searchable: true
            },
            perPage: "",
            currentPage: 1,
            pageSize: 5,
            totalPages: 10,
            SearchQuery: "",
            hasNextPage: "",
            totalData: {},

            selectedItems: [],
            selectAll: false,

            isPopupError: false,
            ispopupShowQuestion: false,
            isPopupSuccess: false,
            isComplete: true,
            filteredList: [],

        };
    },
    computed: {
        // filteredList() {
        //     const query = this.searchQuery.toLowerCase().trim();

        //     const filtered = this.list.filter(item => {
        //         const matchesQuery = query ? item.name.toLowerCase().includes(query) : true;
        //         const hasRelevantSessionDetails = item.SessionDetails &&
        //             item.SessionDetails.length > 0 &&
        //             item.SessionDetails.some(detail => detail.indexNo === 1 && detail.url !== "No recorded video.");
        //         return matchesQuery && hasRelevantSessionDetails;
        //     });
        //     return filtered;
        // },
        //     paginatedFilteredList() {
        //     const query = this.searchQuery.toLowerCase().trim();

        //     const filtered = this.list.filter(item => {
        //         const matchesQuery = query ? item.name.toLowerCase().includes(query) : true;
        //         const hasRelevantSessionDetails = item.SessionDetails &&
        //             item.SessionDetails.length > 0 &&
        //             item.SessionDetails.some(detail => detail.indexNo === 1 && detail.url !== "No recorded video.");
        //         return matchesQuery && hasRelevantSessionDetails;
        //     });

        //     // Apply pagination to the filtered list
        //     const startIndex = (this.currentPage - 1) * this.pageSize;
        //     const endIndex = startIndex + this.pageSize;
        //     return filtered.slice(startIndex, endIndex);
        // },
        defaultDatasets() {
            return [{
                backgroundColor: [

                    '#928AFD'
                ],
                data: [100]
            }]

        },
        // totalItems() {
        //     return this.filteredList.length;
        // },
        // pagedList() {
        //     // Paginate the filtered list based on currentPage and itemsPerPage
        //     const startIndex = (this.currentPage - 1) * this.itemsPerPage;
        //     return this.filteredList.slice(startIndex, startIndex + this.itemsPerPage);
        // },
        // startIndex() {
        //     return (this.currentPage - 1) * this.itemsPerPage + 1;
        // },
        // endIndex() {
        //     return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
        // },
        visiblePageNumbers() {
            const visiblePages = [];
            const totalPagesToShow = 5;
            const halfToShow = Math.floor(totalPagesToShow / 2);

            let startPage = this.currentPage - halfToShow;
            let endPage = this.currentPage + halfToShow;

            if (startPage <= 0) {
                startPage = 1;
                endPage = Math.min(totalPagesToShow, this.totalPages);
            }

            if (endPage > this.totalPages) {
                endPage = this.totalPages;
                startPage = Math.max(1, endPage - totalPagesToShow + 1);
            }

            for (let i = startPage; i <= endPage; i++) {
                visiblePages.push(i);
            }

            return visiblePages;
        },
        formattedAnswer() {
            // Replace the newline characters with <br> for HTML rendering
            return this.questionVideo.Answer.replace(/\n/g, '<br>');
        }

    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser(); // Fetch the user details first
              //  if (this.user.id === 69) {
                    this.getListVideo();
                    this.loadData();
                    this.getTotalReport();
                //}

            } else {
                this.GoToLogin();
            }
        } catch (error) {
            this.GoToLogin();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },
    watch: {
        perPage(newValue) {
            this.pageSize = parseInt(newValue); // Ensure the value is an integer
            this.currentPage = 1; // Reset to the first page
            this.loadData(); // Reload data with new page size
        },
        SearchQuery: function(newVal, oldVal) {
            console.log('SearchQuery updated:', newVal);
            this.loadData();
        },
        isComplete(newVal) {
            console.log("isComplete changed to:", newVal);
        }
    },
    methods: {
        toggleSelectAll() {
            if (this.selectAll) {
                // Select all items
                this.selectedItems = this.filteredList.map(item => item.sessionId);
            } else {
                // Deselect all items
                this.selectedItems = [];
            }
        },
        submitSelected() {
            const sessionJson = this.selectedItems.map(sessionId => {
                const selectedItem = this.filteredList.find(item => item.sessionId === sessionId);
                if (selectedItem) {
                    return {
                        SessionId: selectedItem.sessionId,
                        CandidateUserId: selectedItem.userId,
                        UserId: this.user.id,
                    };
                }
                return null; // Handle case where selectedItem is not found
            }).filter(item => item !== null); // Filter out null entries

            const countCandidate = sessionJson.length;

            if (countCandidate > this.user.credit) {
                this.isPopupError = true;
            } else {
                // Filter selected items from filteredList based on selectedItems

                const formData = new FormData();
                formData.append("candidateJson", JSON.stringify(sessionJson));
                formData.append("countCandidate", countCandidate.toString()); // Ensure countCandidate is a string
                formData.append("companyUserId", this.user.id.toString()); // Ensure companyUserId is a string

                this.$API.post(this.$InsertShorlistedCandidate, formData)
                    .then(response => {
                        if (response.status === 200) {
                            this.isPopupSuccess = true;
                            this.loadData();
                        } else {
                            this.Loading = false;
                            this.Error = true;
                            this.Message = response.data.message;
                        }
                    })
                    .catch(error => {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = error.response.data.message;
                    });
            }

        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async getListVideo() {

            try {
                this.Busy = true;
                const response = await this.$API.get(this.$GetListUserHistory);
                if (response.status === 200) {
                    this.Busy = false;
                    this.list1 = response.data;
                    this.photoURL1 = this.list.profilePhoto;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },

        closePopup1() {
            this.ispopupVisible2 = false;
        },
        OpenPopup() {
            this.ispopupVisible2 = true;
        },
        OpenForm() {
            this.ispopupVisible2 = false;
            this.ispopupVisible3 = true;

        },
        closePopup2() {
            this.ispopupVisible3 = false;
        },

        openVideoPopup(sessionId) {
            //console.log("video" + url);
            // this.videoUrl = url;
            this.getReport(sessionId);
            this.getReportRadar(sessionId);
            this.getReportRank(sessionId);
            this.getReportSummaryRank(sessionId);
            this.getListQuestion(1, sessionId);
            this.getListDoc(sessionId);
            this.ispopupVisible2 = true;
        },

        // Method to close the video popup
        closeVideoPopup() {
            this.isPopupVisible3 = false;
            // Optionally, you can clear the video URL when the popup is closed
            // this.videoUrl = '';
        },
        async nextQuestion(index, sessionId) {
            this.index++;
            this.index1 = index + 1;
            this.showVideo = false;
            console.log("index" + this.index1);
            this.getListQuestion(this.index1, sessionId);

        },
        async getListQuestion(index, sessionId) {
            try {
                const response = await this.$API.get(
                    `${this.$GetNextQuestionVideo}/${sessionId}/${index}`, {
                        withCredentials: true,
                    }
                );
                if (response.status === 200) {
                    this.questionVideo = response.data;
                } else {

                }
            } catch (error) {}

        },
        async getReport(sessionId) {
            try {
                const response = await this.$API.get(this.$GetRank + "?session_id=" + sessionId);
                if (response.status === 200) {
                    this.report = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        async getReportRadar(sessionId) {
            try {
                const response = await this.$API.get(this.$GetRank + "?session_id=" + sessionId);
                if (response.status === 200) {
                    this.reportRadar = response.data;
                    this.processReportData(this.report);
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        processReportData() {
            // Extract Type and Value for labels and data
            this.radarChartData.labels = this.reportRadar.map(item => item.Type);
            this.radarChartData.datasetsRadar[0].data = [0, ...this.reportRadar.map(item => item.Value)]; // Include 0 for proper scaling
        },
        async getReportRank(sessionId) {
            try {
                const response = await this.$API.get(this.$GetRank + "?session_id=" + sessionId);
                if (response.status === 200) {
                    this.reportRank = response.data;
                    console.log("rank" + this.reportRank);
                    this.prepareChartData(this.reportRank);
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        async getReportSummaryRank(sessionId) {
            try {
                const response = await this.$API.get(this.$SessionSummary + "?session_id=" + sessionId);
                if (response.status === 200) {
                    this.reportSummary = this.reformatSummary(response.data.Summary);
                } else {
                    // Handle non-200 status code
                    this.reportSummary = null;
                }
            } catch (error) {
                // Handle the error here
                this.reportSummary = null;
            }
        },
        reformatSummary(summaryText) {
            return summaryText ? summaryText.replace(/:/g, ':\n') : null;
        },
        prepareChartData() {
            const relevantCategories = ['Attitude', 'Communication', 'Sociability', 'Teamwork'];
            const maxScore = 10;

            this.datasets = this.reportRank
                .map(trait => ({
                    data: [trait.Value * 10, (maxScore - trait.Value) * 10],
                    backgroundColor: ['#928AFD', '#E0E0E0'],
                    label: trait.Type
                }));
        },
        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        PrintSectionInvoice() {
    const printSection = document.getElementById('printsection');
    
    html2canvas(printSection, {
        scale: 2,
        useCORS: true,
    }).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'pt',
            format: 'a4',
        });

        const margin = 30; // Margin around the content
        const imgWidth = 595.28 - 2 * margin; // A4 width in points minus margins
        const imgHeight = (canvas.height * imgWidth) / canvas.width; // Calculate height based on width
        let heightLeft = imgHeight;
        let position = margin;

        // Add the image to the first page
        pdf.addImage(imgData, 'PNG', margin, position, imgWidth, imgHeight);
        heightLeft -= (841.89 - 2 * margin); // Subtract the page height minus margins

        // Add additional pages if necessary
        while (heightLeft > 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(imgData, 'PNG', margin, position, imgWidth, imgHeight);
            heightLeft -= (841.89 - 2 * margin); // Subtract the page height minus margins
        }

        pdf.save('download.pdf');
    });
},
async getTotalReport() {
            try {
                const response = await this.$API.get(this.$GetTotalUserHistory + "?isComplete=" + this.isComplete, { withCredentials: true });
                if (response.status === 200) {
                    this.totalData = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
//         loadData() {
//     console.log('isComplete:', this.isComplete);  // Logs the correct value of isComplete (true or false)
//     console.log('Calling API with SearchQuery:', this.SearchQuery);
//     this.Busy = true;
    
//     let url = `read/GetListUserHistory?page=${this.currentPage}&limit=${this.pageSize}&keyword=${this.SearchQuery}&isComplete=${this.isComplete}`;

//     console.log('Complete URL:', url);

//     return this.$API
//       .get(url, { withCredentials: true })
//       .then((response) => {
//         this.Busy = false;
//         if (response.status === 200) {
//           this.list = response.data;
//           this.photoURL = this.list.profilePhoto;
//           this.filteredList = this.list;

//           this.totalPages = Math.ceil(this.totalData / this.pageSize);

//           // Enable or disable next button
//           this.hasNextPage = this.currentPage < this.totalPages;
//         }
//       })
//       .catch((error) => {
//         this.Busy = false;
//         console.error('Error fetching data:', error);
//         this.hasNextPage = false; // Disable next button in case of error
//       });
//   },
loadData() {
    console.log('isComplete:', this.isComplete); // Logs the value of isComplete
    this.Busy = true;

    const url = `read/GetListUserHistory?page=${this.currentPage}&limit=${this.pageSize}&keyword=${this.SearchQuery}&isComplete=${this.isComplete}`;
    console.log('URL:', url);

    this.$API.get(url, { withCredentials: true })
        .then((response) => {
            this.Busy = false;

            if (response.status === 200) {
                this.list = response.data; // Ensure backend provides a paginated `items` array
                this.filteredList = this.list;
                this.totalPages = Math.ceil(this.totalData / this.pageSize);
                this.hasNextPage = this.currentPage < this.totalPages;
                console.log("Total Data:", this.totalData, "Total Pages:", this.totalPages);
            } else {
                console.error("Error: Unexpected response", response);
            }
        })
        .catch((error) => {
            this.Busy = false;
            console.error("Error fetching data:", error);
            this.hasNextPage = false; // Disable Next button on error
        });
},
        loadPage(pageNumber) {
            this.currentPage = pageNumber;
            this.loadData();
        },
        loadFirstPage() {
            this.currentPage = 1;
            this.loadData();
        },
        loadPrevPage() {
            if (this.currentPage > 1) {
                this.currentPage -= 1;
                this.loadData();
            }
        },
        loadNextPage() {
            if (this.hasNextPage) { // Check if next page should be loaded
                this.currentPage += 1;
                this.loadData();
            }
        },
        loadLastPage() {
            this.currentPage = this.totalPages;
            this.loadData();
        },
        closePopup()
        {
          this.isPopupError = false;
        },
        openPopupShowQuestion(item) {
            this.sessionId = item.sessionId;
            this.getListQuestion(1, this.sessionId);
            this.ispopupShowQuestion = true;
        },
        async getListQuestion(index, sessionId) {
            try {
                const response = await this.$API.get(`${this.$GetNextQuestionVideo}/${sessionId}/${index}`, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.questionVideo = response.data;
                } else {}
            } catch (error) {}
        },
        closeVideoShowQuestion()
        {
            this.ispopupShowQuestion = false;
        },
        closeSuccess()
        {
            this.isPopupSuccess = false;
        },
        async getListDoc(sessionId) {
            try {
                const response = await this.$API.get(this.$GetDocDetails + "?sessionId=" + sessionId, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.doc = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
    }

};
</script>



<style scoped>
.watermark {
    position: absolute;
    top: 24%;
    left: 25%;
    transform: rotate(-40deg);
    font-size: 80px;
    color: rgba(0, 0, 0, 0.1);
    /* Adjust opacity as needed */
    pointer-events: none;
    /* Make sure the watermark doesn't interfere with other elements */
    z-index: 1;
}

pre {
    white-space: pre-wrap;
    /* Ensures that newlines and spaces are rendered as expected */
    color: #171717;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    /* 27px */
}
</style>
